import { Alert, Button } from '@src/controls';
import { useFormatMessage } from '@src/i18n';
import React from 'react';

type Props = {
  link: string;
};

export function NewExperienceAlert({ link }: Props) {
  const formatMessage = useFormatMessage();

  return (
    <Alert
      description={formatMessage('NEW_EXPERIENCE_ALERT_DESC')}
      message={formatMessage('NEW_EXPERIENCE_ALERT_TITLE')}
      action={
        <a href={link}>
          <Button type="default" htmlType="button">
            {formatMessage('NEW_EXPERIENCE_ALERT_CTA')}
          </Button>
        </a>
      }
      style={{ marginBottom: '24px' }}
      type="info"
    />
  );
}
